/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _momentMini = _interopRequireDefault(require("moment-mini"));
var _times2 = _interopRequireDefault(require("lodash/times"));
var _TimeCell = _interopRequireDefault(require("./TimeCell"));
var _timeHelper = require("../utils/timeHelper");
var _timeline = _interopRequireDefault(require("./timeline.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultComponents = {
  TimeCell: _TimeCell["default"]
};

/**
 * A timeline component for showing formatted time
 * in time cells at given intervals.
 *
 * Shown at the top of the program guide.
 *
 * @param {object} props See propTypes
 * @returns {Timeline} The Timeline component
 */
var Timeline = function Timeline(_ref) {
  var getXPositionFromTime = _ref.getXPositionFromTime,
    onMoveTo = _ref.onMoveTo,
    startTime = _ref.startTime,
    timeFormat = _ref.timeFormat,
    timeSpan = _ref.timeSpan,
    minutePixelRatio = _ref.minutePixelRatio,
    _ref$cellDuration = _ref.cellDuration,
    cellDuration = _ref$cellDuration === void 0 ? 60 : _ref$cellDuration,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 0 : _ref$height,
    components = _ref.components,
    componentsProps = _ref.componentsProps,
    _ref$vertical = _ref.vertical,
    vertical = _ref$vertical === void 0 ? false : _ref$vertical,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _timeline["default"] : _ref$theme;
  var _defaultComponents$co = _objectSpread(_objectSpread({}, defaultComponents), components),
    TimeCell = _defaultComponents$co.TimeCell;
  var timeCellTheme = theme.timeCell ? theme : undefined;
  var minuteTimespan = (0, _timeHelper.msToMinutes)(timeSpan);
  var horizontalMinutePixelRatio = minutePixelRatio || width / minuteTimespan;
  var verticalMinutePixelRatio = minutePixelRatio || height / minuteTimespan;
  var cellWidth = vertical ? width : (0, _timeHelper.minutesToPixels)(cellDuration, horizontalMinutePixelRatio);
  var cellHeight = !vertical ? height : (0, _timeHelper.minutesToPixels)(cellDuration, verticalMinutePixelRatio);
  var timelineWidth = vertical ? width : (0, _timeHelper.minutesToPixels)(minuteTimespan, horizontalMinutePixelRatio);
  var timelineHeight = !vertical ? height : (0, _timeHelper.minutesToPixels)(minuteTimespan, verticalMinutePixelRatio);
  var nrOfCells = Math.ceil(vertical ? timelineHeight / cellHeight : timelineWidth / cellWidth);
  var _style = _objectSpread({
    width: timelineWidth,
    height: timelineHeight
  }, style);
  var timeCells = (0, _times2["default"])(nrOfCells, function (t) {
    var time = (0, _momentMini["default"])(startTime).add(t * cellDuration, 'minutes');
    var formattedTime = typeof timeFormat === 'function' ? timeFormat(time) : time.format(timeFormat);
    var timeCellProps = componentsProps.TimeCell || {};
    return /*#__PURE__*/_react["default"].createElement(TimeCell, _extends({
      key: t,
      getXPositionFromTime: getXPositionFromTime,
      height: cellHeight,
      onMoveTo: onMoveTo,
      theme: timeCellTheme,
      time: formattedTime,
      timestamp: time.valueOf(),
      vertical: vertical,
      width: cellWidth
    }, timeCellProps));
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.timeline,
    style: _style
  }, timeCells);
};
Timeline.defaultProps = {
  componentsProps: {},
  timeFormat: 'HH:mm'
};
Timeline.propTypes = {
  /**
   * The number of minutes a time cell should represent,
   * deciding how often time labels and separators should
   * be printed.
   */
  cellDuration: T.number,
  /** Overridable components if you want to bring your own */
  components: T.shape({
    TimeCell: T.func
  }),
  /** Extra props passed to the components */
  componentsProps: T.shape({
    TimeCell: T.object
  }),
  getXPositionFromTime: T.func,
  /** The height of the timeline */
  height: T.number,
  /**
   * The ratio transforming minutes to pixels on screen
   * deciding the width of a time cell based on its duration.
   */
  minutePixelRatio: T.number,
  onMoveTo: T.func,
  /** The total start time of the time line */
  startTime: T.number.isRequired,
  /** A style object to be applied to the outer container */
  style: T.object,
  /** Classname API for theming */
  theme: T.shape({
    timeline: T.string
  }),
  /**
   * Time format, either a string as supported by moment.js (e.g. 'HH:mm')
   * or a function for performing formatting.
   * The function should have the following interface:
   * ```timeFormat(time)```
   */
  timeFormat: T.oneOfType([T.string, T.func]),
  /**
   * The time span in milliseconds which the
   * timeline should cover, starting from the startTime
   * value.
   */
  timeSpan: T.number,
  vertical: T.bool,
  /** The visible width of the timeline */
  width: T.number
};
var _default = /*#__PURE__*/_react["default"].memo(Timeline);
exports["default"] = _default;